<!--eslint-disable-->
<template>
    <iframe width="95%" style="position: fixed" height="90%" src="https://app.powerbi.com/reportEmbed?reportId=5953e3e1-8b73-4a4e-a48c-72129febaf44&autoAuth=true&ctid=4ac46c70-3892-49ee-ad43-84d3d6633984&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLWJyYXppbC1zb3V0aC1iLXByaW1hcnktcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D" frameborder="0" allowFullScreen="true"></iframe>
</template>

<script>
import fb from '@/services/firebaseConfig'

const db = fb.db

export default {
    data() {
        return {
            barChartData: [
                ['Ação', 'Distância ao TP'],
                ['NTCO3', 0.5],
                ['PCAR3', 0.2],
                ['BRFS3', 0.15],
                ['STBP3', 0.1],
                ['LREN3', -0.1],
            ],
            pieChartOptions: {
                title: "Percentual na Carteira",
                pieHole: 0.4,
                height: 680,
                width: 900,
                legend: "bottom",
                pieSliceText: 'label'
            },
            barChartOptions: {
                title: "Distância ao TP",
                pieHole: 0.4,
                height: 500
            },
            fundData: []
        }
    },
    methods: {
        teste() {
            console.log(this.computedPieChartData)
        }
    },
    computed: {
        computedPieChartData() {
            let list = [["Ação", "Percentual na Carteira"]]
            this.fundData.forEach(fund => {
                list.push([fund.ticker, fund.fundWeight])
            })
            return list
        }
    },
    created() {
        db.collection("coveredCompanies").orderBy("calculatedFields.fundWeight", "desc")
        .onSnapshot(
            qSnapshot => {
                let list = []
                qSnapshot.forEach(doc => {
                    let obj = doc.data()
                    if(obj.calculatedFields.fundWeight > 0) {
                        list.push({ticker: obj.myTicker, fundWeight: obj.calculatedFields.fundWeight})
                    }
                })
                this.fundData = list
            }
        )
    }
}
</script>
